import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';

const DEVICE_ID_COOKIE = 'device_id';
const DEVICE_ID_TTL = 365 * 100; // 100 years

export function getDeviceId() {
    let deviceId = Cookies.get(DEVICE_ID_COOKIE);
    if (!deviceId) {
        deviceId = uuid();
        Cookies.set(DEVICE_ID_COOKIE, deviceId, { expires: DEVICE_ID_TTL });
    }

    return deviceId;
}
